import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import { useStore } from "../../../../models";
import { GlobalFilterTypes } from "../../../../models/inbox/ConcreteGlobalFilters";

import styles from "../expandedFilters.css";

interface Props {
  resetState(): void;
}

export const UnsnoozedFilter = observer(({ resetState }: Props) => {
  const { inboxStore } = useStore();
  const isActive = inboxStore.globalFilter.isFilterEnabled(GlobalFilterTypes.YoursUnsnoozed);
  const handleChosen = () => {
    inboxStore.globalFilter.toggleFilter(GlobalFilterTypes.YoursUnsnoozed);
    resetState();
  };

  return (
    <div
      className={classNames(styles["entry-container"], { [styles.selected]: isActive })}
      onClick={handleChosen}
    >
      <L10n id="inbox.moreFilters.global.unsnoozed" />
      {isActive && (
        <div className={styles.applied}>
          <L10n id={"inbox.moreFilters.applied"} />
        </div>
      )}
    </div>
  );
});
